import React from 'react'
import { Card, CardContent, TextField, Typography } from '@material-ui/core'
import ParamsEditor from './ParamsEditor'
import { Autocomplete } from '@material-ui/lab'
import instrumentsParams from './instrumentsParams'
import instrumentsPresets from './instrumentsPresets'
import { ContextMenu, ContextMenuTrigger, MenuItem } from 'react-contextmenu'

const instrumentNames = [
	'AMSynth',
	'DuoSynth',
	'FMSynth',
	'MembraneSynth',
	'MetalSynth',
	'MonoSynth',
	'NoiseSynth',
	'PluckSynth',
	'Synth',
	'Sampler',
	'Player',
]

const effectNames = [
	'AutoFilter',
	'AutoPanner',
	'AutoWah',
	'BitCrusher',
	'Chebyshev',
	'Chorus',
	'Distortion',
	'FeedbackDelay',
	'Freeverb',
	'FrequencyShifter',
	'JCReverb',
	'Phaser',
	'PingPongDelay',
	'PitchShift',
	'Reverb',
	'StereoWidener',
	'Tremolo',
	'Vibrato',
	'Compressor',
]

const getChannelWithInstrument = (channel: any, instrument: string, preset: string = '') => {

	if (instrument === 'Sampler')
		return {
			...channel,
			instrument: {
				name: instrument,
				preset,
				params: {
					...instrumentsParams[instrument],
					...(instrumentsPresets[instrument]?.presets[preset])
				}
			}
		}
	else if (instrument === 'Player')
		return {
			...channel,
			instrument: {
				name: instrument,
				preset,
				params: {
					...instrumentsParams[instrument],
					...(instrumentsPresets[instrument]?.presets[preset])
				}
			}
		}
	else if (instrumentNames.includes(instrument))
		return {
			...channel,
			instrument: {
				name: instrument,
				preset,
				params: {
					// @ts-ignore
					...instrumentsParams[instrument],
					...(instrumentsPresets[instrument]?.presets[preset])
				}
			}
		}

	return channel
}

const Channel = (props: {
	channel: any,
	onChange: (channel: any) => void,
	onDelete: (channel: any) => void,
}) => {

	const {
		channel,
		onChange,
		onDelete,
	} = props

	return (
		<Card className='channel' style={{ marginLeft: 24, minWidth: 300, maxWidth: 300 }}>
			<ContextMenuTrigger id={'channel-card-' + channel.idx}>
				<CardContent>

					{/* <Typography variant='h4'>Channel</Typography> */}

					<TextField
						style={{ width: '100%' }}
						value={channel.idx}
						label='Name'
						variant='filled'
						onChange={(e) => onChange({ ...channel, idx: e.target.value })}
					/>

					{/* <Typography variant='h5'>Clips</Typography> */}

					<ParamsEditor
						// @ts-ignore
						name={channel.idx}
						// @ts-ignore
						value={channel.clips}
						onChange={(clips: any) => onChange({ ...channel, clips })}
					/>

					<Autocomplete
						className='instrument'
						autoHighlight
						value={channel.instrument.name}
						options={instrumentNames}
						renderInput={(params: any) => <TextField {...params} label='Instrument' variant='filled' />}
						onChange={(e: any, instrument: any) => onChange(getChannelWithInstrument(channel, instrument))}
					/>

					{instrumentsPresets[channel.instrument.name] && (
						<Autocomplete
							className='preset'
							autoHighlight
							style={{ marginTop: 8 }}
							value={channel.instrument.preset}
							options={instrumentsPresets[channel.instrument.name].list}
							renderInput={(params: any) => <TextField {...params} label='Preset' variant='filled' />}
							onChange={(e: any, preset: any) => onChange(getChannelWithInstrument(channel, channel.instrument.name, preset))}
						/>
					)}

					<ParamsEditor
						// @ts-ignore
						style={instrumentsPresets[channel.instrument.name] ? { } : undefined}
						// @ts-ignore
						name={channel.idx}
						// @ts-ignore
						value={channel.instrument.params}
						onChange={(instrumentsParams: any) => onChange({ ...channel, instrument: { ...channel.instrument, params: instrumentsParams } })}
					/>

					
					<ContextMenu id={'channel-card-' + channel.idx}>
						<MenuItem onClick={(e) => { e.stopPropagation(); onDelete(channel) }}>Delete</MenuItem>
					</ContextMenu>

				</CardContent>
			</ContextMenuTrigger>
		</Card>
	)
}

export default Channel
